var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order"},[_c('div',{staticClass:"main-page__header header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header__inner"},[_c('div',{staticClass:"header__info"},[_c('div',{staticClass:"header__logo"},[_c('HeaderIcon',{attrs:{"name":"logo"}})],1),_c('HeaderLinks')],1)])])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }